export const _WEBSITE_VERSION = 'default'
export const _LOCAL_BUILD = false
export const _LAB_BUILD = true



// WEBPACK FOOTER //
// ./src/constants/global/config.js